import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IStrategy } from "../interface/IStrategy";
import { IBaseResponse } from '../interface/IBaseResponse';

enum StrategyServiceEnum {
  get = "/",
  createOrUpdate = "/",
}

export default class StrategyService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/strategy");
  }

  public getAll = async (): Promise<IStrategy[]> => await this.GET(StrategyServiceEnum.get);
  public createOrUpdate = async (data: IStrategy): Promise<IBaseResponse> => await this.POST(StrategyServiceEnum.createOrUpdate, data);
  public getById = async (id: number): Promise<IStrategy> => await this.GET(StrategyServiceEnum.get + id);
}
